import { createSlice } from "@reduxjs/toolkit";

const providerNavigationSlice = createSlice({
  name: "providerNavigation",
  initialState: {
    activeTab: "Home",
    providerUnreadCount: 0
  },
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    providerIncrementNotification: (state) => {
      state.providerUnreadCount += 1;
    },
    providerResetNotifications: (state) => {
      state.providerUnreadCount = 0;
    },
  },
});

export const { setActiveTab, providerIncrementNotification, providerResetNotifications } = providerNavigationSlice.actions;
export default providerNavigationSlice.reducer;